import axios from 'axios';
import * as Constants from '../common/constants';
import * as HelperFunctions from '../common/functions/helperFunctions';
import AuthService from './authService';

class FileService {

  authService = new AuthService();

  constructor() {
    axios.defaults.baseURL = `${Constants.apiUrl}/`;
    axios.defaults.headers = {
      "Content-Type": "application/json; charset=utf-8",
      Authorization: `Bearer ${this.authService.getToken()}`,
      Pragma: 'no-cache'
    }
  }

  // getOfferFiles(offerId: number) {
  //   return axios({
  //     url: `file/getOfferFiles/${offerId}`,
  //     method: 'get'
  //   })
  //     .then(res => res.data)
  //     .catch(error =>
  //       Promise.reject(HelperFunctions.getErrorMessage(error))
  //     )
  // }

  // getFile(id: number) {
  //   return axios({
  //     url: `file/getFile/${id}`,
  //     method: 'get'
  //   })
  //     .then(res => res.data)
  //     .catch(error =>
  //       Promise.reject(HelperFunctions.getErrorMessage(error))
  //     )
  // }

  // openFile(id: number) {
  //   return axios({
  //     url: `file/openFile/${id}`,
  //     method: 'get',
  //     responseType: 'blob'
  //   })
  //     .then(res => res.data)
  //     .catch(error =>
  //       Promise.reject(HelperFunctions.getErrorMessage(error))
  //     )
  // }

  getFileContent(id: number) {
    return axios({
      url: `file/getFileContent/${id}`,
      method: 'get'
    })
      .then(res => res.data)
      .catch(error =>
        Promise.reject(HelperFunctions.getErrorMessage(error))
      )
  }
}

export default FileService;
